import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';
import { FLOX_LOGO_BLUE_SRC } from '@constants';
import {
  HomeIcon,
  ArrowLeftIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { Button } from '../../tailwindComponents/Button';

export function NotFound() {
  const navigate = useNavigate();

  useDocumentTitle('FLOX - Page Not Found');

  return (
    <main className='flex min-h-screen w-full'>
      {/* Image Panel */}
      <section
        className='hidden md:block md:w-1/2 min-h-screen bg-cover bg-no-repeat bg-center transition-all duration-300'
        style={{ backgroundImage: 'url(/images/bg-login.png)' }}
      />

      {/* Content Panel */}
      <section className='flex-1 flex items-center justify-center bg-white px-4 py-12'>
        <div className='w-full max-w-md'>
          {/* Logo */}
          <div className='flex justify-center mb-8'>
            <img
              src={FLOX_LOGO_BLUE_SRC}
              alt='Flox logo'
              className='h-14 w-auto'
            />
          </div>

          {/* Title */}
          <div className='text-center mb-8'>
            <h1 className='text-6xl font-bold text-gray-900 mb-4'>404</h1>
            <p className='text-xl text-gray-500'>Page not found</p>
          </div>

          {/* Card */}
          <div className='bg-white rounded-2xl shadow-lg border border-gray-100 p-8'>
            <div className='text-center'>
              <div className='flex justify-center mb-4'>
                <div className='rounded-full bg-yellow-100 p-3'>
                  <ExclamationTriangleIcon className='h-8 w-8 text-yellow-600' />
                </div>
              </div>
              <p className='text-gray-600 mb-6'>
                Sorry, we couldn&apos;t find the page you&apos;re looking for.
                The page may have been moved or deleted.
              </p>

              <div className='space-y-3'>
                <Button
                  type='button'
                  intent='primary'
                  size='lg'
                  className='w-full'
                  onClick={() => navigate('/noticeboard')}
                  startIcon={<HomeIcon className='h-5 w-5' />}
                  label='Go to Dashboard'
                />

                <button
                  type='button'
                  onClick={() => navigate(-1)}
                  className='inline-flex items-center justify-center gap-2 w-full py-3 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors'
                >
                  <ArrowLeftIcon className='h-4 w-4' />
                  Go back
                </button>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className='mt-8 text-center'>
            <p className='text-sm text-gray-400'>
              Need help? Contact{' '}
              <a
                href='mailto:support@flox.is'
                className='text-blue-600 hover:underline'
              >
                support@flox.is
              </a>
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
